import SmoothStepEdge from 'pages/Editor/sections/Flow/components/edges/SmoothStepEdge';
import DataNode from 'pages/Editor/sections/Flow/components/nodes/DataNode/DataNode';
import GroupNode from 'pages/Editor/sections/Flow/components/nodes/GroupNode/GroupNode';
import LayerNode from 'pages/Editor/sections/Flow/components/nodes/LayerNode/LayerNode';
import MemoNode from 'pages/Editor/sections/Flow/components/nodes/MemoNode/MemoNode';
import ModelNode from 'pages/Editor/sections/Flow/components/nodes/ModelNode/ModelNode';

export const FLOW_TYPE = {
  NODE: {
    NEW_NODE: 'newnode',
    LAYER_NODE: 'blocknode',
    MODEL_NODE: 'modelnode',
    DATA_NODE: 'datanode',
    GROUP_NODE: 'groupnode',
    MEMO_NODE: 'memonode',
  },
  EDGE: {
    ARROW_EDGE: 'arrowedge',
  },
};

export const NODE_TYPES = {
  [FLOW_TYPE.NODE.LAYER_NODE]: LayerNode,
  [FLOW_TYPE.NODE.DATA_NODE]: DataNode,
  [FLOW_TYPE.NODE.GROUP_NODE]: GroupNode,
  [FLOW_TYPE.NODE.MODEL_NODE]: ModelNode,
  [FLOW_TYPE.NODE.MEMO_NODE]: MemoNode,
};

export const EDGE_TYPES = {
  [FLOW_TYPE.EDGE.ARROW_EDGE]: SmoothStepEdge,
};
